module.exports = __webpack_public_path__ + "public/media/ic_warning_red.76d0feda.svg";